import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { AppDispatch, RootState } from 'interfaces';

import Layout from 'components/Layout';
import ConcertsComponent from 'components/Concerts';
import StatisticSideBar from 'components/StatisticSideBar';

import Loader from 'components/ui/Loader';

import {
  getAllShows,
  getMostPlayedAlbums,
  getMostPlayedSongs,
  getYearsOnTour
} from 'features/statistics/statisticsSlice';

import { getConcerts } from './toursSlice';

interface ConcertsProps {
  isConcertsFestivals?: boolean;
}

const Concerts = ({ isConcertsFestivals } : ConcertsProps) => {
  const { year } = useParams();

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getConcerts({ year }));
  }, [dispatch, year]);

  const years = useSelector((state: RootState) => state.tours.years);
  const yearsFes = useSelector((state: RootState) => state.tours.yearsFes);

  useEffect(() => {
    dispatch(getAllShows({ tourId: isConcertsFestivals ? 'festivals-shows-special-events' : null, limitYear: year || null }));
    dispatch(getMostPlayedSongs({ tourId: isConcertsFestivals ? 'festivals-shows-special-events' : null, limit: 5, limitYear: year || null }));
    dispatch(getMostPlayedAlbums({ tourId: isConcertsFestivals ? 'festivals-shows-special-events' : null, limit: 5, limitYear: year || null }));
    dispatch(getYearsOnTour());
  }, [dispatch, isConcertsFestivals, year]);

  const allShows = useSelector((state: RootState) => state.statistics.allShows);
  const mostPlayedSongs = useSelector((state: RootState) => state.statistics.mostPlayedSongs);
  const mostPlayedAlbums = useSelector((state: RootState) => state.statistics.mostPlayedAlbums);
  const statsYears = useSelector((state: RootState) => state.statistics.years);

  return years ? (
    <Layout sidebar={(
      <StatisticSideBar
        context={isConcertsFestivals || year ? 'year' : 'tour'}
        allShows={allShows}
        mostPlayedSongs={mostPlayedSongs}
        mostPlayedAlbums={mostPlayedAlbums}
        years={statsYears}
      />
    )}>
        <ConcertsComponent
          selectedYear={year || null}
          concerts={isConcertsFestivals ? yearsFes : years}
          isConcertsFestivals={isConcertsFestivals}
        />
      </Layout>
  ) : <Loader />;
};

export default Concerts;
